<adapt-dashboard-element name="Systems"
                         [url]="teamSystemsHref$ | async">
    <ng-container *adaptIfAuthorised="readSystem; entity: team$ | async">
        <ng-container *adaptLoadingUntilFirstEmit="let systems of systems$">
            @if (systems.length > 0) {
                @for (system of systems; track system) {
                    <adapt-link-system class="mb-2"
                                       [system]="system"> </adapt-link-system>
                }
            } @else {
                No systems have been assigned to this team.
            }
        </ng-container>
    </ng-container>
</adapt-dashboard-element>
